import { render } from "./TheTakeProfit.vue?vue&type=template&id=badd8462&scoped=true&ts=true"
import script from "./TheTakeProfit.vue?vue&type=script&lang=ts"
export * from "./TheTakeProfit.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-badd8462"]])

export default __exports__